import axios, { AxiosResponse } from "axios";
import { IAddEditInternalBooking, IInternalBooking } from "../models/internalBooking";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { ApiSearchResponse } from "../models/common";

export const getInternalBooking = async (id: string): Promise<AxiosResponse<IInternalBooking>> => {
    return await axios.get(`/dispatcher/internalBooking/${id}`);
};

export const changeInternalBooking = async (
    dto: IAddEditInternalBooking,
): Promise<AxiosResponse<IInternalBooking>> => {
    return await axios.patch("/dispatcher/internalBooking", dto);
};

export const addInternalBooking = async (
    dto: IAddEditInternalBooking,
): Promise<AxiosResponse<IInternalBooking>> => {
    return await axios.post("/dispatcher/internalBooking", dto);
};

export const searchInternalBooking = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IInternalBooking> => {
    return await axios.post("/dispatcher/internalBooking/search", searchParams);
};

export const deleteInternalBooking = async (guid: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/dispatcher/internalBooking/${guid}`);
};
